import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "fixed top-0 left-0 w-full h-full bg-dark-gray bg-opacity-50 z-50 px-4 flex items-center justify-center md:absolute md:top-14 md:w-auto md:h-auto md:px-0 md:bg-opacity-0" }

import { ref, watch } from 'vue'
import { DatePicker } from 'v-calendar'
import { useBreakpoints, breakpointsTailwind, onClickOutside } from '@vueuse/core'
import { UiInput } from '@/components/common/ui'

import { useHelpers } from '@/composables/useHelpers'

type Props = {
    modelValue?: string
    placeholder?: string
    format?: string
    isRange?: boolean
    /**
     * On mobile devices this component is teleported to body, unfortunately if it is used inside UiPopover (that use Popover from headlesui/vue)
     * focus is being lost and Popover is close. If 'fixOnPopover' is set to true, this component is teleported inside PopoverPanel.
     */
    fixOnPopover?: boolean
}
type Emits = {
    (e: 'update:modelValue', modelValue: string): void
}
type DateRange = {
    start: Date
    end: Date
}

export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: { type: String, required: false, default: '' },
    placeholder: { type: String, required: false, default: '' },
    format: { type: String, required: false, default: 'YYYY-DD-MM' },
    isRange: { type: Boolean, required: false, default: false },
    fixOnPopover: { type: Boolean, required: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'update:modelValue', modelValue: string): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: string, placeholder: string, format: string, isRange: boolean, fixOnPopover?: boolean }




const { formatDate } = useHelpers()

const breakpoints = useBreakpoints(breakpointsTailwind)
const asRegularDatepicker = breakpoints.greater('sm')

const initialValue =
    props.modelValue && props.isRange ? props.modelValue.split(' - ') : props.modelValue
const dateValueAsDate = ref<Date | DateRange>(
    props.isRange
        ? { start: new Date(initialValue[0]), end: new Date(initialValue[1]) }
        : new Date(initialValue),
)
const dateValueAsString = ref<string>(props.modelValue || '')

watch([dateValueAsDate], () => {
    dateValueAsString.value = props.isRange
        ? `${formatDate(dateValueAsDate.value.start)} - ${formatDate(dateValueAsDate.value.end)}`
        : formatDate(dateValueAsDate.value, props.format)
    isDatePickerVisible.value = false
    emit('update:modelValue', dateValueAsString.value)
})

const isDatePickerVisible = ref<boolean>(false)
const datePickeRef = ref()
onClickOutside(datePickeRef, () => (isDatePickerVisible.value = false))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(UiInput), {
      key: dateValueAsString.value,
      modelValue: dateValueAsString.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dateValueAsString).value = $event)),
      clearable: "",
      readonly: "",
      placeholder: props.placeholder,
      onClick: _cache[1] || (_cache[1] = ($event: any) => (isDatePickerVisible.value = true))
    }, null, 8, ["modelValue", "placeholder"]),
    (isDatePickerVisible.value)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 0,
          to: props.fixOnPopover ? '#popover' : 'body',
          disabled: _unref(asRegularDatepicker)
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_unref(DatePicker), {
              ref: (_value, _refs) => {
                _refs['datePickeRef'] = _value
                datePickeRef.value = _value
              },
              modelValue: dateValueAsDate.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dateValueAsDate).value = $event)),
              class: "shadow-md animate-fade-in-up",
              "is-range": props.isRange
            }, null, 8, ["modelValue", "is-range"])
          ])
        ], 8, ["to", "disabled"]))
      : _createCommentVNode("", true)
  ]))
}
}

})